import React from "react";

interface IProps {
  isShowLogout: boolean;
  setIsShowLogout: () => void;
}

const ModalConfirmLogout: React.FC<IProps> = ({
  isShowLogout,
  setIsShowLogout,
}) => {
  const Cookies = require("js-cookie");

  return (
    <div className={`model-group ${isShowLogout ? "active" : ""} `}>
      {isShowLogout && (
        <div className="modal-overlay" onClick={setIsShowLogout}>
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
            style={{
              backgroundImage: `url(${process.env.PUBLIC_URL || ""}/assets/bg-frame-login.png)`,
              backgroundSize: "100% 100%",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
            }}
          >
            
            {/* Title XÁC NHẬN */}
            <div className="modal-title">
              XÁC NHẬN
            </div>
            
            {/* Text thủ thuật */}
            <div className="modal-text">
              Bạn có chắc muốn đăng xuất không?
            </div>
            
            {/* Buttons accept và cancel */}
            <div className="modal-buttons">
              <img 
                src="/assets/accept.png" 
                alt="Accept" 
                className="modal-button accept-button"
                onClick={() => {
                  Cookies.remove("access_token");
                  setIsShowLogout();
                  window.location.reload();
                  localStorage.removeItem("user_info");
                }}
              />
              <img 
                src="/assets/cancel.png" 
                alt="Cancel" 
                className="modal-button cancel-button"
                onClick={setIsShowLogout}
              />
            </div>
          </div>
        </div>
      )}
      <style
        dangerouslySetInnerHTML={{
          __html: `
/* Modal Styles - Copy from CongThucPage.css */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
}

.modal-content {
  background: linear-gradient(135deg, #003f3c, #005652);
  border-radius: 20px;
  padding: 40px;
  text-align: center;
  max-width: 520px;
  width: 90%;
  min-height: 240px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
}

.modal-icon {
  margin-bottom: 20px;
}

.question-icon {
  width: 120px;
  height: 120px;
  display: block;
  margin: 0 auto;
}

.modal-title {
  color: white;
  font-size: 30px;
  font-weight: bold;
  margin-bottom: 8px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.modal-text {
  color: #ffc300;
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 10px;
  width: 100%;
  text-align: center;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
}

.modal-buttons {
  display: flex;
  justify-content: center;
  gap: 12px;
}

.modal-button {
  width: 138px;
  max-height: 42px;
  cursor: pointer;
  transition: transform 0.3s ease;
  object-fit: contain;
}

.modal-button:hover {
  transform: scale(1.1);
}

/* Responsive Modal */
@media (max-width: 768px) {
  .modal-content {
    padding: 16px 20px;
    max-width: 380px;
    min-height: 210px;
  }
  
  .question-icon {
    width: 100px;
    height: 100px;
  }
  
  .modal-title {
    font-size: 24px;
  }
  
  .modal-text {
    font-size: 18px;
  }
  
  .modal-button {
    width: 118px;
    max-height: 36px;
    object-fit: contain;
  }
}

@media (max-width: 480px) {
  .modal-content {
    padding: 14px 16px;
    max-width: 400px;
    min-height: 340px;
  }
  
  .question-icon {
    width: 80px;
    height: 80px;
  }
  
  .modal-title {
    font-size: 22px;
  }
  
  .modal-text {
    font-size: 16px;
  }
  
  .modal-button {
    width: 106px;
    max-height: 32px;
    object-fit: contain;
  }
}
`,
        }}
      />
    </div>
  );
};

export default ModalConfirmLogout;
